var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import orgs_model from "@iscr/models/orgs_model";
/**
 * Returns all the available orgs for a nurse user from their device and profile orgs
 */
export const getNurseAvailableOrgs = (user) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const dvgOrg = ((_a = app.dvc) === null || _a === void 0 ? void 0 : _a.org) || null;
    const availableOrgMap = new Map(((_b = dvgOrg === null || dvgOrg === void 0 ? void 0 : dvgOrg.availableOrgs) !== null && _b !== void 0 ? _b : []).concat((_d = (_c = user.org) === null || _c === void 0 ? void 0 : _c.availableOrgs) !== null && _d !== void 0 ? _d : []).map(o => [o.oid, o]));
    const availableOrgs = Array.from(availableOrgMap.values());
    const userAvailableOids = new Set((_g = (_f = (_e = user.org) === null || _e === void 0 ? void 0 : _e.availableOrgs) === null || _f === void 0 ? void 0 : _f.map((o) => o.oid)) !== null && _g !== void 0 ? _g : []);
    return {
        availableOrgMap,
        availableOrgs,
        userAvailableOids,
    };
};
/**
 * Assign a device org if the user is a nurse. Prefers org on dvc_data, but will fall back to profile org
 */
export const assignDeviceOrg = () => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c;
    // If there's an actual device org associated, load that
    const dvc_org = ((_a = app.dvc.dvc_data) === null || _a === void 0 ? void 0 : _a.oid) &&
        (yield orgs_model.get_record(null, null, { act: "getdvcorg", oid: app.dvc.dvc_data.oid }));
    // If there's no device org, but the user has an org, fallback to their profile org
    if (app.dvc.dvc_data && !((_b = app.dvc.dvc_data) === null || _b === void 0 ? void 0 : _b.oid) && ((_c = app.user.org) === null || _c === void 0 ? void 0 : _c.oid)) {
        app.dvc.dvc_data.oid = app.user.org.oid;
        // flag when we're using an oid available through the user's profile so we can tell the diff
        app.dvc.dvc_data.oid_from_profile = true;
        // This device has no stored org at all - the two fields above are this user's own org standing in
        // for one, in memory only.
        app.dvc.dvc_data.oid_local_only = true;
    }
    // Use device org if it exists, otherwise fall back to user's org if it exists, otherwise false for backwards compat
    app.dvc.org = dvc_org || app.user.org || false;
});
